/**
 * Performs a one-time cache bust by clearing service worker registrations and cached resources
 * until a specified expiration date. This method is intended to update the service worker and
 * ensure clients use the latest version of the application.
 *
 * The method clears cache only if the current date is before the specified expiration date and
 * ensures it is executed only once per user by setting a flag in local storage.
 *
 * @return {void} This function does not return a value.
 */
export function oneTimeCacheBust() {
  // Add this temporarily with a date check so it auto-expires
  const CACHE_CLEAR_EXPIRY = new Date('2025-09-30'); // Set your expiry date

  if (new Date() < CACHE_CLEAR_EXPIRY && 'serviceWorker' in navigator) {
    console.log('Performing one-time cache clear for service worker update');

    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (let registration of registrations) {
        registration.unregister();
      }
    });

    caches.keys().then(cacheNames => {
      return Promise.all(
        cacheNames.map(cacheName => {
          return caches.delete(cacheName);
        })
      );
    });

    // Set a flag so this only runs once per user
    if (!localStorage.getItem('cache-cleared-2025-08')) {
      localStorage.setItem('cache-cleared-2025-08', 'true');
      // Force reload after cache clear
      setTimeout(() => window.location.reload(), 1000);
    }
  }
}
